module.exports = __webpack_public_path__ + "static/media/logo-padilla-cabecera.038c1a4e.svg";